<template>
  <transition name="fade">
    <div v-if="showAlert" class="alert-popup">
      <div class="alert-message">
        <button class="close-btn" @click="closeAlert">×</button> <!-- Close button -->
        <h4>报警信息</h4>
        <p><strong>告警类型：</strong>{{ alertInfo.type }}</p>
        <p><strong>设备名称：</strong>{{ alertInfo.device }}</p>
        <p><strong>发生时间：</strong>{{ alertInfo.time }}</p>
        <p><strong>详情：</strong>{{ alertInfo.details }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showAlert: false,
      alertInfo: {
        type: '',
        device: '',
        time: '',
        details: ''
      }
    };
  },
  methods: {
    showAlertMessage(alertInfo) {
      this.alertInfo = alertInfo;
      this.showAlert = true;
    },
    closeAlert() {
      this.showAlert = false;
    }
  }
};
</script>

<style scoped>
.alert-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  color: white;
  z-index: 9999;
}

.alert-message {
  background: #333;
  padding: 15px;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}
</style>
